"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CwImage = _interopRequireDefault(require("../../cwimage/CwImage"));

var _classnames = _interopRequireDefault(require("classnames"));

var _CwDataGrid = _interopRequireDefault(require("../CwDataGrid.scss"));

var CellFlags = function CellFlags(props) {
  var _cx, _cx2, _cx4;

  return _react.default.createElement("div", {
    "data-cw-grid-cell-flags": true,
    className: _CwDataGrid.default.cell,
    style: {
      width: props.col.width,
      padding: '4px 16px'
    }
  }, props.row.status === 'Online' && _react.default.createElement("span", {
    title: "Agent Status: Online"
  }, _react.default.createElement(_CwImage.default, {
    className: (0, _classnames.default)(_CwDataGrid.default.cellImage, _CwDataGrid.default.success),
    src: props.flagIconsSrc.Tile_AgentStatus
  })), props.row.status === 'Offline' && _react.default.createElement("span", {
    title: "Agent Status: Offline"
  }, _react.default.createElement(_CwImage.default, {
    className: (0, _classnames.default)(_CwDataGrid.default.cellImage, _CwDataGrid.default.failed),
    src: props.flagIconsSrc.Flag_AgentOffline
  })), _react.default.createElement("span", {
    title: "Master"
  }, _react.default.createElement(_CwImage.default, {
    className: (0, _classnames.default)(_CwDataGrid.default.cellImage, (_cx = {}, (0, _defineProperty2.default)(_cx, _CwDataGrid.default.disabled, props.row.MasterMode === 'Off'), (0, _defineProperty2.default)(_cx, _CwDataGrid.default.success, props.row.MasterMode === 'Master'), _cx)),
    src: props.flagIconsSrc.Flag_Master
  })), _react.default.createElement("span", {
    title: "Maintenance Mode"
  }, _react.default.createElement(_CwImage.default, {
    className: (0, _classnames.default)(_CwDataGrid.default.cellImage, (_cx2 = {}, (0, _defineProperty2.default)(_cx2, _CwDataGrid.default.inMaintenance, props.row.isMaintenanceModeEnabled), (0, _defineProperty2.default)(_cx2, _CwDataGrid.default.disabled, !props.row.isMaintenanceModeEnabled), _cx2)),
    src: props.flagIconsSrc.Flag_MaintenanceMode
  })), _react.default.createElement("span", {
    title: "Heartbeat"
  }, _react.default.createElement(_CwImage.default, {
    className: (0, _classnames.default)(_CwDataGrid.default.cellImage, (0, _defineProperty2.default)({}, _CwDataGrid.default.disabled, !props.row.isHeartbeatRunning)),
    src: props.flagIconsSrc.Flag_HeartBeat
  })), _react.default.createElement("span", {
    title: "Locked Down"
  }, _react.default.createElement(_CwImage.default, {
    className: (0, _classnames.default)(_CwDataGrid.default.cellImage, (_cx4 = {}, (0, _defineProperty2.default)(_cx4, _CwDataGrid.default.disabled, !props.row.isLockedDown), (0, _defineProperty2.default)(_cx4, _CwDataGrid.default.failed, props.row.isLockedDown), _cx4)),
    src: props.row.isLockedDown ? props.flagIconsSrc.Status_Locked : props.flagIconsSrc.Status_Unlocked
  })), _react.default.createElement("span", {
    title: "Local User"
  }, _react.default.createElement(_CwImage.default, {
    className: (0, _classnames.default)(_CwDataGrid.default.cellImage, (0, _defineProperty2.default)({}, _CwDataGrid.default.disabled, !props.row.isLocalAccount)),
    src: props.flagIconsSrc.Flag_LocalUser
  })), _react.default.createElement("span", {
    title: "Network Probe"
  }, _react.default.createElement(_CwImage.default, {
    className: (0, _classnames.default)(_CwDataGrid.default.cellImage, (0, _defineProperty2.default)({}, _CwDataGrid.default.disabled, !props.row.isNetworkProbe)),
    src: props.flagIconsSrc.Flag_NetworkProbe
  })), props.row.isFasTalk && _react.default.createElement("span", {
    title: "FasTalk On"
  }, _react.default.createElement(_CwImage.default, {
    className: (0, _classnames.default)(_CwDataGrid.default.cellImage),
    src: props.flagIconsSrc.Flag_FasTalkConnected
  })), !props.row.isFasTalk && _react.default.createElement("span", {
    title: "FasTalk Off"
  }, _react.default.createElement(_CwImage.default, {
    className: (0, _classnames.default)(_CwDataGrid.default.cellImage, _CwDataGrid.default.disabled),
    src: props.flagIconsSrc.Flag_FasTalk
  })), _react.default.createElement("span", {
    title: "Reboot Required"
  }, _react.default.createElement(_CwImage.default, {
    className: (0, _classnames.default)(_CwDataGrid.default.cellImage, (0, _defineProperty2.default)({}, _CwDataGrid.default.disabled, !props.row.isRebootNeeded)),
    src: props.flagIconsSrc.Flag_PendingReboot
  })), _react.default.createElement("span", {
    title: "Tunnels"
  }, _react.default.createElement(_CwImage.default, {
    className: (0, _classnames.default)(_CwDataGrid.default.cellImage, (0, _defineProperty2.default)({}, _CwDataGrid.default.disabled, !props.row.isTunnelSupported)),
    src: props.flagIconsSrc.Flag_Tunnels
  })), _react.default.createElement("span", {
    title: "Virtual Machine"
  }, _react.default.createElement(_CwImage.default, {
    className: (0, _classnames.default)(_CwDataGrid.default.cellImage, (0, _defineProperty2.default)({}, _CwDataGrid.default.disabled, !props.row.isVirtualMachine)),
    src: props.flagIconsSrc.Flag_VirtualMachine
  })));
};

CellFlags.propTypes = {
  col: _propTypes.default.object.isRequired,
  row: _propTypes.default.object.isRequired,
  flagIconsSrc: _propTypes.default.object.isRequired
};
var _default = CellFlags;
exports.default = _default;